export default __webpack_public_path__ + "static/media/mission-quote-asset.8279b6d5.png";